import apiFetch from '../../apiFetch'

export default function (idLicencia) {
  return apiFetch({endPoint: `admin/Empresa/eliminarEmpresa?idLicencia=` + idLicencia, method: 'GET'})
}
